import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-incentives-upgrade',
    templateUrl: './incentives-upgrade.component.html',
    styleUrls: ['./incentives-upgrade.component.scss'],
})
export class IncentivesUpgradeComponent implements OnInit {
    headline: string;
    shortOverview: string;
    selligPointHeader: string;
    logoPlaceholder: string;
    moduleShortDescription: string;
    backgroundColor: string;

    constructor() {}
    ngOnInit() {
        this.setUpgradePage();
    }

    setUpgradePage() {
        this.headline =
            'Motivate production and quality with strategic compensation plans and metrics';
        this.shortOverview = 'Ensure your commissions and bonuses are driving the right behavior.';
        this.selligPointHeader =
            'Track LO Commissions, Unearned Guarantees, and Draw Balance in one place';
        this.logoPlaceholder = 'src/assets/images/upgrade_thumbnails/incentives_upgrade.png';
        this.moduleShortDescription =
            'CompenSafe is the premier industry incentive compensation engine.' +
            ' See why you can motivate more production through smart, accurate, and transparent compensation plans.';
        this.backgroundColor = '#fff9e7';
    }
}
